const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5003/',
};

export default config;
